import { defineStore } from 'pinia'

export const useReviewStore = defineStore('reviewStore', {
  state: () => ({
    reviewsList: [],
  }),
  actions: {
    updateReview(review) {
      this.reviewsList = review
    },
  },
  persist: true,
})
